var map = {
	"./Accounting.svg": "b11c",
	"./Block.svg": "94e7",
	"./Logs.svg": "ca8e",
	"./country.svg": "3b0b",
	"./exchange-rate.svg": "e232",
	"./icons": "2137",
	"./icons.vue": "2137",
	"./partners.svg": "9c07",
	"./serviceCharge.svg": "f43b",
	"./settings.svg": "9174",
	"./transactions.svg": "628c",
	"./users.svg": "d956"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";